<!-- // -----------------------------------------------------------------------------
// <copyright file="popover.component.html" company="ecoInsight, Inc.">
// 	Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------ -->
<div class="popover-container">
	<ng-content></ng-content>
</div>
